import { getJson } from '../ext-core';

/**
 * Fetches semantically similar listings from the host-proxy route
 * `GET /api/empavision/search?keywords=<>&limit=<>`.
 *
 * The proxy forwards to the empavision saas-starter endpoint
 * `/api/listings/semantic-search` which is entitlement-gated server-side
 * (the client gate in `RecommendedSection` is a UX-only convenience — the
 * server is the enforcement point per TASK157 D2).
 *
 * Server contract (TASK157 subtask 0.3):
 *   { results: [{ listingId, title, priceAmount, priceCurrency, similarity, imageUrls }] }
 *   imageUrls: Array<{ originalUrl, azureBlobUrl, variants }>
 *
 * Fail-soft: any network/parse failure returns `[]`, never throws.
 * The dead 0.35 client-side similarity filter is NOT applied here —
 * the server already threshold-filters at the per-tenant config value
 * (default 0.60, raised from the old hardcoded 0.35). See TASK157 §"redundancy".
 *
 * @param {string} keywords  - the search query string
 * @param {{ limit?: number, rootUrl?: string }} [opts]
 * @returns {Promise<Array<{ listingId: string, title: string, priceAmount: number, priceCurrency: string, similarity: number, imageUrls: Array<object> }>>}
 */
export const fetchSimilar = async (keywords, { limit, rootUrl } = {}) => {
  if (!keywords || !keywords.trim()) {
    return [];
  }

  const params = { keywords: keywords.trim() };
  if (limit !== undefined && limit !== null) {
    params.limit = limit;
  }

  const data = await getJson('/api/empavision/search', { params, rootUrl });

  // Fail-soft: null means network/parse error; missing .results also safe.
  if (!data || !Array.isArray(data.results)) {
    return [];
  }

  return data.results;
};
